import React from "react";
import "./dividers.scss";

export const Active = ({ ...props }) => {
  return <div className="scd_active_tab_dash" />;
};
